import React from "react";
import { getHospitalLogoClassName, getHospitalLogoSrc } from "../../utils/hospitalLogo";

export { getHospitalLogoClassName, getHospitalLogoSrc, TELECARE_LOGO_SRC } from "../../utils/hospitalLogo";

export const HospitalLogo: React.FC<{ klassName?: string }> = ({ klassName = "logo" }) => {
  return <img src={getHospitalLogoSrc()} alt="Hospital logo" className={getHospitalLogoClassName(klassName)} />;
};
